export default function FloatingUploadButton({
  fileInputRef,
  onFileChange,
  uploading,
  uploadProgress,
}) {
  return (
    <div className="sticky bottom-4 self-end -mr-4 z-40 mt-auto pt-4">
      <label
        className="bg-rose-500 hover:bg-rose-600 active:scale-95 text-white p-3.5 rounded-full shadow-xl flex items-center justify-center cursor-pointer transition-all duration-200 group"
        title="Upload Photos"
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          onChange={onFileChange}
          className="hidden"
          disabled={uploading}
        />
        {uploading ? (
          <span className="text-xs font-semibold px-1">{uploadProgress}%</span>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        )}
      </label>
    </div>
  );
}
